const ZOOM_MODULE_IDS = {
  ZOOM_CONTROLLER: Symbol.for('zoomController'),
  ZOOM_EVENTS: Symbol.for('zoomEvents'),
};

export { ZOOM_MODULE_IDS };
